import {
    Button,
    Flex,
    Heading,
    Link,
    Box
} from '@chakra-ui/react';
import React, { useEffect, useRef, useState } from 'react';
import Swal from 'sweetalert2';
import SituacaoJuridicaService from "../../../main/services/SituacaoJuridicaService";
import VisualizarInfo from '../Doenca/VisualizarInfo';
import { Link as ReactLink, useHistory } from 'react-router-dom';
import SemRegistros from '../../components/SemRegistros';
import { useAuthProvider } from '../../../Context/AuthProvider';
import { situacaoJuridica as situacaoJuridicaFunc } from '../../../helpers/Funcionalidades'

const VisualizarSituacaoJuridica = (props) => {

    let history = useHistory();
    document.title = 'MCA - Situação Jurídica - Visualizar'

    const { roleKeycloack } = useAuthProvider();
    const _IsMounted = useRef(false);
    const [situacaoJuridica, setSituacaoJuridica] = useState([])
    const [isUpdating] = useState(props.match.params.editar ? true : false)

    useEffect(() => {

        _IsMounted.current = true;
        fetchData();
        return () => {
            _IsMounted.current = false;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])



    function fetchData() {
        SituacaoJuridicaService.getSituacaoJuridica(props.match.params.id)
            .then(res => {
                setSituacaoJuridica(res.data);
            }).catch((err) => {
                Swal.fire({
                    title: 'Atenção!',
                    'text': "Registro não encontrado",
                    icon: 'warning',
                    confirmButtonText: 'Fechar',
                    confirmButtonColor: '#169499'
                }).then(() => {
                    history.push("/situacao-juridica/lista")
                })
            })
    }

    function checkStatus(acao) {
        let updated;
        SituacaoJuridicaService.getSituacaoJuridica(props.match.params.id)
            .then(res => {
                updated = res.data
                const acaoUp = updated.dataFim ? "reativar" : "inativar";
                if (acaoUp !== acao) {
                    Swal.fire({
                        title: 'Atenção',
                        text: updated.dataFim ?
                            "Este registro já está inativo. Deseja reativá-lo?" :
                            "Este registro está ativo. Deseja inativá-lo?",
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#169499',
                        cancelButtonColor: '#169499',
                        confirmButtonText: updated.dataFim ?
                            "Sim, quero reativar!" :
                            "Sim, quero inativar!",
                        cancelButtonText: 'Cancelar'
                    }).then((result) => {
                        if (result.isConfirmed) {
                            history.push("/situacao-juridica/alterar-vigencia/" + updated.id);
                        }
                    })
                } else {
                    history.push("/situacao-juridica/alterar-vigencia/" + updated.id);
                }
            })
    }

    return roleKeycloack && roleKeycloack.includes(situacaoJuridicaFunc.situacaoJuridicaVisualizar) ? (

        <Flex
            pt={"20px"}
            px={["5px", "30px"]}
            h="100%"
            flexDir="column"
            w="100%"
            maxW="2000px"
            overflow="auto"
            pb={["10px", "20px"]}
        >
            <Flex
                flexDir="row"
                justifyContent="space-between"
            >

                <Heading fontSize={'large'}>
                    Visualizar Situação Jurídica
                </Heading>
                <Link as={ReactLink}
                    to="/situacao-juridica/lista"
                    _hover={{ textDecoration: "none" }}
                >
                    <Button colorScheme={"teal"} px={16}>
                        Voltar
                    </Button>
                </Link>
            </Flex>
            <Flex
                flexDir="column"
            >
                <Flex
                    mt="25px"
                    flexDir="column"
                    borderRadius="20px"
                    w="100%"
                    overflow="hidden"
                >
                    <VisualizarInfo
                        title="Descrição"
                        info={situacaoJuridica.descricao || ""}
                        bgColor="#F9FAFB"
                    />
                    <VisualizarInfo
                        title="Tipo de Situação Jurídica"
                        info={
                            situacaoJuridica.tipo === "P"
                                ? "Processo"
                                : "Procedimento"
                        }
                        bgColor="#FFFFFF"
                    />
                    <VisualizarInfo
                        title="Data Início"
                        info={new Date(situacaoJuridica.dataInicio).toLocaleDateString("PT-br") || ""}
                        bgColor="#F9FAFB"
                    />
                    {
                        situacaoJuridica.dataFim &&
                        (
                            <VisualizarInfo
                                title="Data Fim"
                                info={new Date(situacaoJuridica.dataFim).toLocaleDateString("PT-br")}
                                bgColor="#FFFFFF"
                            />
                        )
                    }
                    {
                        situacaoJuridica.justificativa &&
                        (
                            <VisualizarInfo
                                title={
                                    situacaoJuridica.dataFim == null && situacaoJuridica.justificativa == null
                                        ? "Justificativa"
                                        :
                                        (
                                            situacaoJuridica.dataFim == null && situacaoJuridica.justificativa != null
                                                ? "Justificativa da Reativação"
                                                : "Justificativa da Inativação"
                                        )
                                }
                                info={situacaoJuridica.justificativa || ""}
                                bgColor={situacaoJuridica.dataFim ? "#F9FAFB" : "#FFFFFF"}
                            />
                        )
                    }
                </Flex>

                <Flex mt={2} justifyContent="space-between">
                    <Flex></Flex>
                    <Flex flexDir={"row"}>
                        {situacaoJuridica.dataFim ? (
                            <></>
                        ) : (
                            <Link as={ReactLink} to={"/situacao-juridica/editar/" + situacaoJuridica.id} _hover={{ textDecoration: 'none' }}>
                                <Button
                                    mr={2}
                                    mt={4}
                                    colorScheme={"teal"}

                                    px={14}
                                    type="button">
                                    {isUpdating ? "Cancelar" : "Editar"}
                                </Button>
                            </Link>
                        )}
                        <Button
                            mt={4}
                            mr={2}
                            colorScheme={"teal"}
                            px={14}
                            data-acao={situacaoJuridica.dataFim ? "reativar" : "inativar"}
                            onClick={(e) => { checkStatus(e.target.dataset.acao) }}
                            type="button">
                            {situacaoJuridica.dataFim ? "Reativar" : "Inativar"}
                        </Button>

                    </Flex>
                </Flex>


            </Flex>
        </Flex>
    ) : (
        <Box mt={2}>
            <SemRegistros buttonVisible={true} half />
        </Box>
    );
}
export default VisualizarSituacaoJuridica;